import { DesignChannelType, DesignNoInputTimeoutOverride } from '../../types';

// Values in milliseconds
export const noInputTimeoutOverrideDefaults: DesignNoInputTimeoutOverride & Record<'default', string> = {
  [DesignChannelType.email]: '',
  [DesignChannelType.facebook]: '30000',
  [DesignChannelType.instagram]: '',
  [DesignChannelType.mobile]: '',
  [DesignChannelType.other]: '30000',
  [DesignChannelType.sms]: '30000',
  [DesignChannelType.socialChat]: '',
  [DesignChannelType.twitter]: '',
  [DesignChannelType.voice]: '10000',
  [DesignChannelType.webChat]: '30000',
  [DesignChannelType.whatsApp]: '',
  default: '10000'
};
